<template>
    <v-dialog
    v-model="localValue"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Nova skupina
      </v-card-title>

      <v-card-text>
        <CategoryForm
          ref="categoryForm"
          :modalView="true"
          @save="saveAndClose"
          @cancel="cancel"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CategoryForm from './CategoryForm'

export default {
  components: {
    CategoryForm
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  methods: {
    saveAndClose (form) {
      this.$emit('input', false)
      this.$emit('confirmed', form)
    },
    cancel () {
      this.clearForm()
      this.$emit('input', false)
    },
    clearForm () {
      this.$refs.categoryForm.clearForm()
    }
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
